/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    HistoryPressReleasesResponseAllOf,
    HistoryPressReleasesResponseAllOfFromJSON,
    HistoryPressReleasesResponseAllOfFromJSONTyped,
    HistoryPressReleasesResponseAllOfToJSON,
} from './HistoryPressReleasesResponseAllOf';
import {
    HistoryPressReleasesResponseAllOfData,
    HistoryPressReleasesResponseAllOfDataFromJSON,
    HistoryPressReleasesResponseAllOfDataFromJSONTyped,
    HistoryPressReleasesResponseAllOfDataToJSON,
} from './HistoryPressReleasesResponseAllOfData';
import {
    MediaUserApiResponse,
    MediaUserApiResponseFromJSON,
    MediaUserApiResponseFromJSONTyped,
    MediaUserApiResponseToJSON,
} from './MediaUserApiResponse';

/**
 * 今まで閲覧したプレスリリース一覧を取得したときのレスポンス
 * @export
 * @interface HistoryPressReleasesResponse
 */
export interface HistoryPressReleasesResponse {
    /**
     * ステータスコード
     * @type {number}
     * @memberof HistoryPressReleasesResponse
     */
    status: number;
    /**
     * ステータスメッセージ
     * @type {string}
     * @memberof HistoryPressReleasesResponse
     */
    message: string;
    /**
     * 
     * @type {HistoryPressReleasesResponseAllOfData}
     * @memberof HistoryPressReleasesResponse
     */
    data: HistoryPressReleasesResponseAllOfData;
}

export function HistoryPressReleasesResponseFromJSON(json: any): HistoryPressReleasesResponse {
    return HistoryPressReleasesResponseFromJSONTyped(json, false);
}

export function HistoryPressReleasesResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryPressReleasesResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'message': json['message'],
        'data': HistoryPressReleasesResponseAllOfDataFromJSON(json['data']),
    };
}

export function HistoryPressReleasesResponseToJSON(value?: HistoryPressReleasesResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'message': value.message,
        'data': HistoryPressReleasesResponseAllOfDataToJSON(value.data),
    };
}

